import { render, staticRenderFns } from "./BrandListView.vue?vue&type=template&id=64549eff&scoped=true&"
import script from "./BrandListView.vue?vue&type=script&lang=js&"
export * from "./BrandListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64549eff",
  null
  
)

export default component.exports